import { mountReactChartChooser } from "./react";
import { ChartChooserStore } from "./store";
import "./tailwind.css";
import "./index.css";

// Keep unique - other stylesheets set .hidden to display: none, breaking Office's insert snapshot. ZVE-1290
const HIDDEN_CLASS_NAME = "chart-chooser-hidden";

function hideDOMBody() {
    const bodyElement = document.getElementsByTagName("body")[0];
    bodyElement.classList.add(HIDDEN_CLASS_NAME);
}

function showDOMBody() {
    const bodyElement = document.getElementsByTagName("body")[0];
    bodyElement.classList.remove(HIDDEN_CLASS_NAME);
}

export function mountChartChooser(setVisible: boolean = false) {
    hideDOMBody();
    mountReactChartChooser(setVisible);
    // ChartChooserToggle has been moved to GlobalToolbar
    setTimeout(() => showDOMBody(), 300);
}

export function initChartChooserStore() {
    new ChartChooserStore();
}
